import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=314edc3a&scoped=true"
import script from "./VideoPreview.vue?vue&type=script&lang=js"
export * from "./VideoPreview.vue?vue&type=script&lang=js"
import style0 from "./VideoPreview.vue?vue&type=style&index=0&id=314edc3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314edc3a",
  null
  
)

export default component.exports